import { useMemo } from 'react';

import { useFetchPlansByTierIdQuery } from '@order/graphql';
import { useSweetpassTier } from '@order/hooks';

import { useSubscriptionPlansByIdsQuery } from './graphql/Plan.generated';

/**
 * Finds the plan id for the most recent free trial plan.
 */
export function useFreeTrialPlanId() {
  const { sweetpassNextTierId } = useSweetpassTier('cache-and-network');

  const nextTierId = sweetpassNextTierId;

  const [plansByTierId] = useFetchPlansByTierIdQuery({
    variables: { tierId: nextTierId ?? '' },
    pause: !nextTierId,
  });

  const planIds = useMemo(
    () =>
      plansByTierId.data?.fetchPlansByTierId?.map(
        (plan) => plan.braintreePlanId,
      ) ?? [],
    [plansByTierId.data?.fetchPlansByTierId],
  );

  const [plansResponse] = useSubscriptionPlansByIdsQuery({
    variables: { planIds },
    pause: planIds.length === 0,
  });

  const plans = plansResponse.data?.subscriptionPlansByIds ?? [];
  const freeTrialPlans = plans.filter((plan) => plan.hasFreeTrial);
  const mostRecentFreeTrialPlan = freeTrialPlans.at(-1);
  const freeTrialPlanId = mostRecentFreeTrialPlan?.id;

  const isLoadingFreeTrialPlanId =
    plansByTierId.fetching || plansResponse.fetching;

  return {
    freeTrialPlanId,
    isLoadingFreeTrialPlanId,
  };
}
